type ScoreSource = {
  attemptStatus?: string | null;
  scorePercent?: number | null;
  lastAttemptScorePercent?: number | null;
};

export function scorePercentForDisplay(learnerTraining?: ScoreSource | null) {
  if (!learnerTraining) return 0;

  if (learnerTraining.attemptStatus === 'failed') {
    return (
      learnerTraining.lastAttemptScorePercent ??
      learnerTraining.scorePercent ??
      0
    );
  }

  return learnerTraining.scorePercent ?? 0;
}
